// const { t, i18n } = useTranslation();
// i18n.changeLanguage('zh_CN')
// console.log(t)
import React from "react";
// import { Player, ControlBar } from "video-react";
import Nav from "./Nav";
import About from "./About";
import News from "./News";
import "../../assets/styles/mobile_style.scss";
class Home extends React.Component {
  state = {
    topIconShow: false,
    navListShow: true,
    navForm: null, // 导航
    player: null, // 首页视频
    aboutForm: null, //关于我们
    newsForm: null, //媒体之声
  };
  componentWillUnmount() {
    this.setState = ()=>false;
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
    setTimeout(() => {
      const mobilePage = window.localStorage.getItem("mobilePage");
      if (mobilePage) {
        this.toPage(Number(mobilePage));
        window.localStorage.removeItem("mobilePage");
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    }, 300);
  }
  handleScroll = () => {
    //滚动条高度
    let scrollTop = document.documentElement.scrollTop; //滚动条滚动高度
    console.log(scrollTop);
    if (scrollTop >= 300) {
      this.setState({
        topIconShow: true,
        navListShow: false,
      });
    } else {
      this.setState({
        topIconShow: false,
      });
      if (scrollTop <= 50) {
        this.setState({
          navListShow: true,
        });
      }
    }
  };
  // 首页视频播放
  onPlayer = (ref) => {
    this.setState({
      player: ref,
    });
  };
  // 子组件传实例this
  componentRef = (ref, type) => {
    switch (type) {
      case "nav":
        this.setState({
          navForm: ref,
        });
        break;
      case "about":
        this.setState({
          aboutForm: ref,
        });
        break;
      case "news":
        this.setState({
          newsForm: ref,
        });
        break;
      default:
        break;
    }
  };
  // 导航跳转到对应位置
  toPage = (index) => {
    console.log(index);
    let scrollTop = 0;
    if (index === 0) {
      // this.props.history.push("/");
    } else if (index === 1) {
      scrollTop = 510;
    } else if (index === 2) {
      scrollTop = 1180;
    } else if (index === 21) {
      scrollTop = 1780;
    } else if (index === 3) {
      scrollTop = 2440;
    } else if (index === 4) {
      scrollTop = 3210;
    }
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
  };
  // 二级导航
  toSecondPage = (page) => {
    let scrollTop = 0;
    if (page === "CBU") {
      scrollTop = 1180;
    } else if (page === "EBU") {
      scrollTop = 1780;
    }
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
  };
  // 跳转产品二级页面
  toCBU = () => {
    this.props.history.push("/CBU");
  };
  toEBU = () => {
    this.props.history.push("/EBU");
  };
  // 返回顶部
  toTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
  // 跳转备案网站
  toRecord = () => {
    window.open("https://beian.miit.gov.cn/#/Integrated/index");
  };
  render() {
    const { topIconShow, navListShow } = this.state;
    return (
      <div
        className="mobile-container"
        ref={(ref) => {
          this.refDom = ref;
        }}
      >
        <div className="nav-container">
          {/* 导航栏 */}
          <Nav
            componentRef={this.componentRef}
            navIndex={this.navIndex}
            toPage={this.toPage}
            logoClick={this.toPageHome}
            toSecondPage={this.toSecondPage}
            navListShow={navListShow}
          />
        </div>
        <div className="video-container">
          {/* <Player
            ref={this.onPlayer}
            fluid={true}
            muted={true}
            autoPlay={true}
            loop={true}
            src={require("../../assets/video/logo.MP4").default}
          >
            <ControlBar
              autoHide={false}
              disableDefaultControls={true}
            ></ControlBar>
          </Player> */}
          <img
            className="video-bg"
            src={
              require("@/assets/images/mobile-images/logo.gif").default
            }
            alt=""
          />
        </div>
        <div className="about-container">
          {/* 关于我么 */}
          <About componentRef={this.componentRef} />
        </div>
        <div className="product-container">
          <img
            className="product-bg"
            src={
              require("@/assets/images/mobile-images/product-bg.jpg").default
            }
            alt=""
          />
          <div className="area-click area-CBU" onClick={this.toCBU} />
          <div className="area-click area-EBU" onClick={this.toEBU} />
        </div>
        <div className="news-container">
          {/* 媒体之声 */}
          <News componentRef={this.componentRef} />
        </div>
        <div className="contact-container">
          <img
            className="contact-bg"
            src={
              require("@/assets/images/mobile-images/contact-1-bg.jpg").default
            }
            alt=""
          />
          <img
            className="contact-bg"
            src={
              require("@/assets/images/mobile-images/contact-2-bg.jpg").default
            }
            alt=""
          />
          <div className="area-click beian" onClick={this.toRecord} />
        </div>
        {/* 返回顶部 */}
        {topIconShow ? (
          <div className="toTop" onClick={this.toTop}>
            <img src={require("@/assets/images/toTop.png").default} alt="" />
          </div>
        ) : null}
      </div>
    );
  }
}

export default Home;
